/**
 * @format
 * @flow
 */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Modal from '../../components/Common/Modal';
import * as RT from '../../constants/Routing';
import * as Actions from '../../actions/Contact';

import Template from '../../components/Template/AfterLoginTemplate';

const typeTexts = {
  1: 'ご利用方法に関するお問い合わせ',
  2: '請求額に関するお問い合わせ',
  3: 'その他お問い合わせ'
};

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));
    this.state = {
      openCheck: false,
      closeCheck: true,
      type: '1',
      mail: '',
      description: ''
    };
  }

  // eslint-disable-next-line class-methods-use-this
  _getTypeText(type) {
    return typeTexts[type];
  }

  _setValue = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  _check = e => {
    this.setState({ openCheck: true, closeCheck: false });
  };

  _cancel = () => {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.modalCloseInAuth();
    this.setState({ openCheck: false, closeCheck: true });
  };

  _contact = () => {
    this.setState({ openCheck: false, closeCheck: false });
    // eslint-disable-next-line react/destructuring-assignment
    this.props.sendContact(
      this.currentUser.enterpriseId,
      this.currentUser.accessToken,
      this.state.mail,
      this.state.description,
      this.state.type
    );
  };

  _moveToTop = () => {
    this.props.modalCloseInAuth();
    this.props.history.push(RT.TOP_PATH);
  };

  render = () => {
    return (
      <Template>
        <Modal
          isOpen={this.state.openCheck}
          closeModal={this.state.closeCheck}
          headerTitle="以下の内容を送信します、よろしいですか？"
          okClickHandler={null}
        >
          <div className="row text-left" style={{ width: '350px', margin: '0px auto' }}>
            <div className="col-12">
              <label className="badge badge-success">種別</label>
              <p>{this._getTypeText(this.state.type)}</p>
            </div>
            <div className="col-12">
              <label className="badge badge-success">担当者様のメールアドレス</label>
              <p>{this.state.mail}</p>
            </div>
            <div className="col-12">
              <label className="badge badge-success">お問い合わせ内容</label>
              <p>{this.state.description}</p>
            </div>
            <div className="text-center mt-4 col-md">
              <span className="btn btn-success" onClick={this._cancel}>
                修正する
              </span>
            </div>
            <div className="text-center mt-4 col-md">
              <span className="btn btn-primary" onClick={this._contact}>
                はい
              </span>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.props.App.modalOpen}
          closeModal={this.props.modalCloseInAuth}
          headerTitle="お問い合わせ"
          okClickHandler={null}
        >
          <div>{this.props.App.modalText}</div>
          <div className="text-center mt-4 col-md">
            <span className="btn btn-primary" onClick={this._moveToTop}>
              トップへ戻る
            </span>
          </div>
          <div className="text-center mt-4 col-md">
            <span className="btn btn-info" onClick={this._cancel}>
              閉じる
            </span>
          </div>
        </Modal>
        <div className="">
          <h2>サポート</h2>
          <div className="row">
            <div className="form-group position-relative col-8">
              <label htmlFor="contactType">種別</label>
              <select
                name="type"
                className="form-control"
                id="contactType"
                value={this.state.type}
                onChange={this._setValue}
              >
                <option value="1">{this._getTypeText('1')}</option>
                <option value="2">{this._getTypeText('2')}</option>
                <option value="3">{this._getTypeText('3')}</option>
              </select>
            </div>
            <div className="form-group position-relative col-8">
              <label htmlFor="contactName">担当者様のメールアドレス</label>
              <input
                type="mail"
                name="mail"
                className="form-control"
                id="contactMail"
                placeholder=""
                value={this.state.mail}
                onChange={this._setValue}
              />
            </div>
            <div className="form-group position-relative col-8">
              <label htmlFor="contactDescription">お問い合わせ内容</label>
              <textarea
                type="text"
                name="description"
                className="form-control"
                id="contactDescription"
                placeholder=""
                style={{ height: '200px' }}
                value={this.state.description}
                onChange={this._setValue}
              />
            </div>
            <div className="form-group position-relative col-8 text-center">
              <button type="button" onClick={this._check} className="btn btn-primary">
                確認する
              </button>
            </div>
          </div>
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
